<div class="modal-backdrop" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="onClose()" aria-label="Close modal">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.4002 13.3L0.700195 12.6L6.3002 6.99995L0.700195 1.39995L1.4002 0.699951L7.0002 6.29995L12.6002 0.699951L13.3002 1.39995L7.7002 6.99995L13.3002 12.6L12.6002 13.3L7.0002 7.69995L1.4002 13.3Z" fill="#3F4350"/>
      </svg>
    </button>

    <header class="modal-header">
      <p>{{ partner.name }}</p>
    </header>

    <div class="modal-body" id="disclaimer-desc" tabindex="-1">
      <p>{{ 'partners.contact_modal.city' | translate }}: {{ partner.city }}</p>
      <p>{{ 'partners.contact_modal.address' | translate }}: {{ partner.address }}</p>
      <p>{{ 'partners.contact_modal.phone' | translate }}: {{ partner.phone }}</p>
      <p>{{ 'partners.contact_modal.email' | translate }}: {{ partner.email }}</p>
    </div>
  </div>
</div>


